'use client';

import { useState } from "react";
import NextImage, { StaticImageData, ImageProps } from "next/image";
import LightboxGallery from "./LightboxGallery";

interface MDXImageProps extends ImageProps {
  images?: { src: string | StaticImageData; title?: string }[];
  aspectRatio?: "video" | "square" | "auto";
}

const MDXImage = ({
  src,
  alt,
  images,
  aspectRatio = "video",
  ...props
}: MDXImageProps) => {
  const [open, setOpen] = useState(false);

  const srcStr = typeof src === 'string' ? src : (src as StaticImageData).src;

  const galleryImages = images?.length
    ? images.map(img => ({
        src: typeof img.src === 'string' ? img.src : (img.src as StaticImageData).src,
        title: img.title || '',
      }))
    : [{ src: srcStr, title: '' }];

  // 👈 FIXED: Template literal + explicit heights
  const containerClasses = `
    relative block w-full max-w-4xl mx-auto m-0 p-0
    h-[50vh] sm:h-[55vh] md:h-[60vh] lg:h-[50vh] overflow-hidden
    rounded-[1.5rem] border-2 border-zinc-200/80 dark:border-zinc-800/80 shadow-xl
    cursor-zoom-in bg-zinc-900/10 dark:bg-zinc-900/30
    ${aspectRatio === "video" ? "aspect-video" : ""}
    ${aspectRatio === "square" ? "aspect-square max-h-[70vh]" : ""}
    ${aspectRatio === "auto" ? "h-[70vh] md:h-[80vh]" : ""}
  `;

  return (
    <div className="my-10 w-full">
      <div className={containerClasses} onClick={() => setOpen(true)}>

        {/* 👈 Main: CORNERS TOUCH CONTAINER */}
        <NextImage
          {...props}
          src={srcStr}
          alt={alt || "Image"}
          fill
          sizes="(max-width: 1024px) 100vw, 80vw"
          priority
          className="!absolute inset-0 !w-full !h-full z-10 object-cover object-top transition-all duration-500 hover:scale-[1.02]"
          style={{ 
            objectPosition: 'top center',
            objectFit: 'cover'
          }}
        />
      </div>

      {open && <LightboxGallery images={galleryImages} />}
    </div>
  );
};

export default MDXImage;
